var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCuartoBasuras(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 214.852,
    height: 249.226,
    viewBox: "0 0 214.852 249.226",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #262626;\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CuartoBasuras",
    transform: "translate(834.925 -8566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2723",
    "data-name": "Path 2723",
    className: "cls-1",
    d: "M150.076,60.626h-5.939a12.891,12.891,0,0,0,0,25.782h4.671l15.41,169.529a21.488,21.488,0,0,0,21.4,19.538h106.11a21.488,21.488,0,0,0,21.4-19.538l15.41-169.529h4.671a12.891,12.891,0,1,0,0-25.782h-5.939l-11.249-22.5A21.485,21.485,0,0,0,296.8,26.25H180.542a21.485,21.485,0,0,0-19.216,11.877ZM319.905,86.409H157.433l15.341,168.753a12.89,12.89,0,0,0,12.84,11.723h106.11a12.891,12.891,0,0,0,12.84-11.723ZM277.343,34.844v4.3a12.89,12.89,0,0,1-12.891,12.891H212.888A12.89,12.89,0,0,1,200,39.141v-4.3H180.539a12.893,12.893,0,0,0-11.529,7.125l-9.329,18.658h27.424a4.3,4.3,0,1,1,0,8.594h-42.97a4.3,4.3,0,0,0,0,8.594H333.2a4.3,4.3,0,1,0,0-8.594H204.294a4.3,4.3,0,0,1,0-8.594H317.657l-9.329-18.658A12.893,12.893,0,0,0,296.8,34.844Zm-8.594,0v4.3a4.3,4.3,0,0,1-4.3,4.3H212.888a4.3,4.3,0,0,1-4.3-4.3v-4.3Z",
    transform: "translate(-966.171 8539.75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2724",
    "data-name": "Path 2724",
    className: "cls-1",
    d: "M266.641,201.25a12.9,12.9,0,0,0-12.891,12.891V317.27a12.891,12.891,0,0,0,25.783,0V214.141a12.9,12.9,0,0,0-12.891-12.891Zm0,8.594a4.3,4.3,0,0,0-4.3,4.3V317.27a4.3,4.3,0,1,0,8.594,0V214.141a4.3,4.3,0,0,0-4.3-4.3Z",
    transform: "translate(-1028.514 8450.69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2725",
    "data-name": "Path 2725",
    className: "cls-1",
    d: "M336.641,201.25a12.9,12.9,0,0,0-12.891,12.891V317.27a12.891,12.891,0,0,0,25.783,0V214.141a12.9,12.9,0,0,0-12.891-12.891Zm0,8.594a4.3,4.3,0,0,0-4.3,4.3V317.27a4.3,4.3,0,1,0,8.594,0V214.141a4.3,4.3,0,0,0-4.3-4.3Z",
    transform: "translate(-1064.138 8450.69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2726",
    "data-name": "Path 2726",
    className: "cls-1",
    d: "M406.641,201.25a12.9,12.9,0,0,0-12.891,12.891V317.27a12.891,12.891,0,0,0,25.783,0V214.141a12.9,12.9,0,0,0-12.891-12.891Zm0,8.594a4.3,4.3,0,0,0-4.3,4.3V317.27a4.3,4.3,0,1,0,8.594,0V214.141a4.3,4.3,0,0,0-4.3-4.3Z",
    transform: "translate(-1099.762 8450.69)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuartoBasuras);
export default __webpack_public_path__ + "static/media/CuartoBasuras.3f6a256f72e7f07f4192aa5a7c7ef9de.svg";
export { ForwardRef as ReactComponent };